import moment from 'moment-jalaali'

import { lang } from '../localization'

export type InventoryChannel = {
  name: string
  price: number[]
  closed: boolean[]
  CTA: boolean[]
  CTD: boolean[]
  minStay: number[]
  maxStay: number[]
  availability: number[]
  extraBedPrice: number[]
  breakfastPrice: number[]
}

export type InventoryRateplan = {
  name: string
  price: number[]
  closed: boolean[]
  CTA: boolean[]
  CTD: boolean[]
  minStay: number[]
  maxStay: number[]
  availability: number[]
  extraBedPrice: number[]
  breakfastPrice: number[]
  // cancelPolicy: string[]
  channels: InventoryChannel[]
}

export type InventoryRoomtype = {
  name: string
  availability: number[]
  rateplans: InventoryRateplan[]
}

export type InventoryChannelType = {
  name: string
  price: NumberFieldData[]
  closed: BooleanFieldData[]
  CTA: BooleanFieldData[]
  CTD: BooleanFieldData[]
  minStay: NumberFieldData[]
  maxStay: NumberFieldData[]
  extraBedPrice: NumberFieldData[]
  breakfastPrice: NumberFieldData[]
  allocatedAvail: NumberFieldData[]
}

export type InventoryRateplanType = {
  name: string
  price: NumberFieldData[]
  closed: BooleanFieldData[]
  CTA: BooleanFieldData[]
  CTD: BooleanFieldData[]
  minStay: NumberFieldData[]
  maxStay: NumberFieldData[]
  extraBedPrice: NumberFieldData[]
  breakfastPrice: NumberFieldData[]
  channels: InventoryChannelType[]
}

export type NumberFieldData = {
  date: string
  value: number
  manual?: boolean
  editedValue?: string // this could be like: 10000 or +10% or -10%
}

export type BooleanFieldData = {
  date: string
  value: boolean
  edited?: boolean
  editedValue?: string
}

export type SingleRoomTypeData = {
  name: string
  availability: NumberFieldData[]
  rateplans: InventoryRateplanType[]
}

export const generateInventoryMockData = (): SingleRoomTypeData[] => {
  const roomTypes =
    lang === 'fa'
      ? ['اتاق یک تخته', 'اتاق کینگ', 'اتاق دونفره']
      : ['Single Room', 'King Room', 'Twin Room']
  const ratePlans =
    lang === 'fa'
      ? ['نرخ پایه', 'نرخ به همراه صبحانه', 'نرخ فول بورد']
      : ['Room Only', 'Breakfast Included', 'Full Board']
  const channels =
    lang === 'fa' ? ['اسنپ تریپ', 'علی بابا'] : ['Snapp', 'Ali baba']
  return roomTypes.map((singleRoomType) => ({
    name: singleRoomType,
    availability: Array(300)
      .fill('')
      .map((item, index) => ({
        date: moment().add(index, 'day').format('YYYY-MM-DD'),
        value: Math.floor(Math.random() * 50)
      })),
    rateplans: ratePlans.map((singleRatePlan) => ({
      name: singleRatePlan,
      price: Array(300)
        .fill('')
        .map((item, index) => ({
          date: moment().add(index, 'day').format('YYYY-MM-DD'),
          value: Math.floor(Math.random() * 1000 + 100) * 10000
        })),
      closed: Array(300)
        .fill('')
        .map((item, index) => ({
          date: moment().add(index, 'day').format('YYYY-MM-DD'),
          value: Math.floor(Math.random() * 10) === 0
        })),
      CTA: Array(300)
        .fill('')
        .map((item, index) => ({
          date: moment().add(index, 'day').format('YYYY-MM-DD'),
          value: false
        })),
      CTD: Array(300)
        .fill('')
        .map((item, index) => ({
          date: moment().add(index, 'day').format('YYYY-MM-DD'),
          value: false
        })),
      minStay: Array(300)
        .fill('')
        .map((item, index) => ({
          date: moment().add(index, 'day').format('YYYY-MM-DD'),
          value: 1
        })),
      maxStay: Array(300)
        .fill('')
        .map((item, index) => ({
          date: moment().add(index, 'day').format('YYYY-MM-DD'),
          value: 100
        })),
      extraBedPrice: Array(300)
        .fill('')
        .map((item, index) => ({
          date: moment().add(index, 'day').format('YYYY-MM-DD'),
          value: 500000
        })),
      breakfastPrice: Array(300)
        .fill('')
        .map((item, index) => ({
          date: moment().add(index, 'day').format('YYYY-MM-DD'),
          value: 600000
        })),
      channels: channels.map((singleChannel) => ({
        name: singleChannel,
        price: Array(300)
          .fill('')
          .map((item, index) => ({
            date: moment().add(index, 'day').format('YYYY-MM-DD'),
            value: Math.floor(Math.random() * 1000 + 100) * 10000
          })),
        closed: Array(300)
          .fill('')
          .map((item, index) => ({
            date: moment().add(index, 'day').format('YYYY-MM-DD'),
            value: Math.floor(Math.random() * 10) === 0
          })),
        CTA: Array(300)
          .fill('')
          .map((item, index) => ({
            date: moment().add(index, 'day').format('YYYY-MM-DD'),
            value: false
          })),
        CTD: Array(300)
          .fill('')
          .map((item, index) => ({
            date: moment().add(index, 'day').format('YYYY-MM-DD'),
            value: false
          })),
        minStay: Array(300)
          .fill('')
          .map((item, index) => ({
            date: moment().add(index, 'day').format('YYYY-MM-DD'),
            value: 1
          })),
        maxStay: Array(300)
          .fill('')
          .map((item, index) => ({
            date: moment().add(index, 'day').format('YYYY-MM-DD'),
            value: 100
          })),
        allocatedAvail: Array(300)
          .fill('')
          .map((item, index) => ({
            date: moment().add(index, 'day').format('YYYY-MM-DD'),
            value: 0
          })),
        extraBedPrice: Array(300)
          .fill('')
          .map((item, index) => ({
            date: moment().add(index, 'day').format('YYYY-MM-DD'),
            value: 500000
          })),
        breakfastPrice: Array(300)
          .fill('')
          .map((item, index) => ({
            date: moment().add(index, 'day').format('YYYY-MM-DD'),
            value: 600000
          }))
      }))
    }))
  }))
}

export const inventorymockData: InventoryRoomtype[] = [
  {
    name: 'Single Room',
    availability: [12, 14, 16, 18, 1, 12, 4, 12, 14, 16, 18, 1, 12, 4],
    rateplans: [
      {
        name: 'Room Only',
        price: [
          480, 320, 48, 323, 423, 300, 480, 320, 48, 323, 423, 300, 120, 500
        ],
        closed: [
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false
        ],
        CTA: [
          false,
          false,
          false,
          false,
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false
        ],
        CTD: [
          false,
          false,
          false,
          true,
          false,
          false,
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false
        ],
        minStay: [1, 1, 1, 4, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1],
        maxStay: [10, 10, 10, 4, 10, 10, 4, 10, 10, 10, 10, 10, 10, 10],
        availability: [10, 10, 10, 4, 10, 10, 4, 10, 10, 10, 10, 10, 10, 10],
        extraBedPrice: [
          480, 320, 48, 323, 423, 300, 480, 320, 48, 323, 423, 300, 120, 500
        ],
        breakfastPrice: [
          480, 320, 48, 323, 423, 300, 480, 320, 48, 323, 423, 300, 120, 500
        ],
        channels: [
          {
            name: 'Ali baba',
            price: [
              480, 320, 48, 323, 423, 300, 480, 320, 48, 323, 423, 300, 120, 500
            ],
            closed: [
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false
            ],
            CTA: [
              false,
              false,
              false,
              false,
              true,
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false
            ],
            CTD: [
              false,
              false,
              false,
              true,
              false,
              false,
              true,
              false,
              false,
              false,
              false,
              false,
              false,
              false
            ],
            minStay: [1, 1, 1, 4, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1],
            maxStay: [10, 10, 10, 4, 10, 10, 4, 10, 10, 10, 10, 10, 10, 10],
            availability: [
              10, 10, 10, 4, 10, 10, 4, 10, 10, 10, 10, 10, 10, 10
            ],
            extraBedPrice: [
              480, 320, 48, 323, 423, 300, 480, 320, 48, 323, 423, 300, 120, 500
            ],
            breakfastPrice: [
              480, 320, 48, 323, 423, 300, 480, 320, 48, 323, 423, 300, 120, 500
            ]
          },
          {
            name: 'Ali baba',
            price: [
              480, 320, 48, 323, 423, 300, 480, 320, 48, 323, 423, 300, 120, 500
            ],
            closed: [
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false
            ],
            CTA: [
              false,
              false,
              false,
              false,
              true,
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false
            ],
            CTD: [
              false,
              false,
              false,
              true,
              false,
              false,
              true,
              false,
              false,
              false,
              false,
              false,
              false,
              false
            ],
            minStay: [1, 1, 1, 4, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1],
            maxStay: [10, 10, 10, 4, 10, 10, 4, 10, 10, 10, 10, 10, 10, 10],
            availability: [
              10, 10, 10, 4, 10, 10, 4, 10, 10, 10, 10, 10, 10, 10
            ],
            extraBedPrice: [
              480, 320, 48, 323, 423, 300, 480, 320, 48, 323, 423, 300, 120, 500
            ],
            breakfastPrice: [
              480, 320, 48, 323, 423, 300, 480, 320, 48, 323, 423, 300, 120, 500
            ]
          }
        ]
      }
    ]
  }
]
